import {openModalConfirm} from 'js/services/modals'
import template from './_form.pug'

export default Vue.extend({
  template: template(),
  props: {
    initData: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    saveButtonText: {
      type: String,
      default: () => Vue.i18n.t('general.save')
    }
  },
  data() {
    return {
      data: {}
    }
  },
  computed: {
  },
  watch: {
    initData: {
      immediate: true,
      handler() {
        this.initializeData()
      }
    }
  },
  created() {

  },
  methods: {

    testSMS() {
      openModalConfirm(
        this.$t('customers.masiv.modalConfirm.title'),
        this.$t('customers.masiv.modalConfirm.body'),
        this.$t('customers.masiv.modalConfirm.okButton')
      ).then(() => {       
        API.smsMasiv.testSMSLinkMobility(this.data).then(response => {
          if (response.data.response) {
            this.$notifications.success(this.$t('customers.masiv.edit.succesfullyTested'))
          } else {
            this.$notifications.warning(this.$t('customers.lmasiv.edit.warning'))
          }
        })
      })
    },

    initializeData() {
      this.data = this.initData
    },

    t(key, options = {}) {
      return this.$t(`customers.masiv.form.${key}`, options)
    },

    submit() {
      this.$emit('submit', this.data)
    },

    cancel() {
      this.$emit('cancel')
    }
  }
})
